import { render, staticRenderFns } from "./TicketsListView.vue?vue&type=template&id=295a8df4&scoped=true"
import script from "./TicketsListView.vue?vue&type=script&lang=js"
export * from "./TicketsListView.vue?vue&type=script&lang=js"
import style0 from "./TicketsListView.vue?vue&type=style&index=0&id=295a8df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295a8df4",
  null
  
)

export default component.exports